import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import { useDroppable } from '@dnd-kit/core';

import styleService from '../services/StyleService';

const DndKitDroppable = observer((props = {}) => {
  const { className, droppableId, index, style, title, tabIndex} = props;

  // eslint-disable-next-line no-empty-pattern
  const {
    /* managers */
  } = useContext(MobXProviderContext);

  const { isOver, setNodeRef } = useDroppable({
    
    data: {
      droppableId,
      index
    },
    id: droppableId
  });

  const { getStyleVar } = styleService;

  // Create a more descriptive ARIA label for drop zones
  const getAriaLabel = () => {
    if (title) {
      return `Drop zone for ${title}`;
    }
    
    // If we have an index, use it for better accessibility
    if (index !== undefined && index !== null) {
      return `Drop zone ${index}`;
    }
    
    // Try to extract a meaningful name from the droppableId
    const blankMatch = droppableId.match(/blank(\d+)/i);
    if (blankMatch) {
      return `Drop zone for blank ${blankMatch[1]}`;
    }
    const labelMatch = droppableId.match(/label(\d+)/i);
    if (labelMatch) {
      return `Drop zone for label ${labelMatch[1]}`;
    }
    return `Empty Drop Zone`;
  };

  return (
    <div
      ref={setNodeRef}
      className={classNames(className, 'dnd-kit-droppable')}
      style={{
        ...style,
        ...(isOver ? {
          backgroundColor: getStyleVar('--theme-drag-drop-dragover-color')
        } : {})
      }}
      title={title}
      tabIndex={tabIndex}
      role="region"
      aria-label={getAriaLabel()}>
      {props.children}
    </div>
  );
});

export default DndKitDroppable;
